import type { EmployeePublic } from "./api";

export function initials(fullName: string): string {
  const cleaned = fullName.replace(/,.*$/, "").replace(/\b(PhD|Dr|د\.?)\b/gi, "").trim();
  const parts = cleaned.split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0] ?? "").join("").toUpperCase();
}

function digitsOnly(value: string): string {
  return value.replace(/[^\d]/g, "");
}

function defaultPrefilledText(employee: EmployeePublic): string {
  const name = (employee.full_name ?? "").trim();
  const firstName = name.split(/\s+/)[0] || "there";
  return `Hi ${firstName}, great to connect!`;
}

export function whatsappLink(employee: EmployeePublic): string | null {
  if (!employee.whatsapp_number) return null;
  const number = digitsOnly(employee.whatsapp_number);
  if (!number) return null;
  // No more [c:<slug>] or [src:...] tags in the visible message — those were
  // routing/attribution tokens for the WhatsApp AI agent (Kapso), which per
  // the M18 direction is being retired in favor of the app's scan flow. Source
  // attribution already happens at the QR-scan step (link_scans.campaign_tag)
  // before the chat even starts, so nothing is lost by dropping it here too —
  // this is now a plain, professional prefilled greeting, editable per
  // employee via PATCH /api/me/card (prefilled_text).
  const text = (employee.prefilled_text ?? "").trim() || defaultPrefilledText(employee);
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
